<template>
  <sticky-header-layout>
    <template #header>
      <div class="filter-container">
        <div class="filter-item">
          <span class="filter-title">Date:</span>
          <gx-date-range-select
            :date-range.sync="filter.dateRange"
            :disabled="isLoading"
            @selectedDateRange="handleSelectedDateRange"
          />
        </div>
        <div class="filter-item">
          <span class="filter-title">Affiliate:</span>
          <el-select
            :disabled="isLoading"
            v-model="filter.affiliate"
            @change="handleAffiliteChange"
          >
            <el-option
              v-for="item in affiliates"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </div>
        <div class="filter-item">
          <span class="filter-title">Advertiser:</span>
          <el-select
            :disabled="isLoading"
            v-model="filter.advertiser"
            @change="handleAdvertiserChange"
          >
            <el-option
              v-for="item in advertisers"
              :key="item.id"
              :label="`${item.name} (${item.affiliate} ${item.advertiser_id})`"
              :value="`${item.affiliate},,${item.advertiser_id}`"
            />
          </el-select>
        </div>
        <div class="filter-item">
          <span class="filter-title">Marketing U1:</span>
          <el-input
            v-model="filter.marketing_u1"
            :disabled="isLoading"
            clearable
          />
        </div>
      </div>
      <div class="action-container">
        <div class="button-container">
          <el-button
            :loading="isGeneratingCSV"
            type="warning"
            icon="el-icon-download"
            size="mini"
            @click="handleExportCSV"
          >
            Export CSV
          </el-button>
        </div>
      </div>
    </template>
  </sticky-header-layout>
</template>

<script>
import format from 'date-fns/format'
import { generateSalesCSV } from '../../api/reports'
import { getStoreList } from '../../api/stores'
import AffiliateService from '../../api/affiliates'

export default {
  name: 'SalesReport',
  data() {
    return {
      filter: this.getDefaultFilter(),
      affiliates: [],
      allAdvertisers: [],
      advertisers: [],
      dateRangeOptions: [
        { value: 'lastSevenDays', label: 'Last 7 Days' },
        { value: 'thisWeek', label: 'This Week' },
        { value: 'lastWeek', label: 'Last Week' },
        { value: 'thisMonth', label: 'This Month' },
        { value: 'lastMonth', label: 'Last Month' },
        { value: 'lastThirtyDays', label: 'Last 30 Days' },
        { value: 'custom', label: 'Custom' },
      ],
      customDateRange: [],
      isLoading: false,
      isGeneratingCSV: false,
    }
  },
  mounted() {
    this.getStores()
    this.getAffiliates()
  },
  methods: {
    getDefaultFilter() {
      return {
        dateRange: { value: 'thisMonth', label: 'This Month' },
        affiliate: '',
        advertiser_id: '',
        advertiser_affiliate: '',
        advertiser: '',
        marketing_u1: '',
      }
    },
    getPayload() {
      return {
        startDate: (this.customDateRange[0]) ? format(this.customDateRange[0], 'yyyy-MM-dd') : null,
        endDate: (this.customDateRange[1]) ? format(this.customDateRange[1], 'yyyy-MM-dd') : null,
        affiliate: (this.filter.advertiser) ? this.filter.advertiser_affiliate : this.filter.affiliate,
        advertiser_id: this.filter.advertiser_id,
        marketing_u1: this.filter.marketing_u1,
      }
    },
    async getStores() {
      this.isLoading = true
      try {
        const response = await getStoreList('all')
        const allAdvertisers = response.data
        allAdvertisers.forEach((advertiser) => {
          if (advertiser.affiliate === 'MP' && ['216','416','616','816'].includes(advertiser.advertiser_id)) {
            advertiser.affiliate = 'EL' //hack gg to el
          }
          this.allAdvertisers.push(advertiser)
        })
        this.advertisers = this.allAdvertisers
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
      // console.log(this.advertisers)
    },
    async getAffiliates() {
      const response = await AffiliateService.getAffiliateList()
      const affiliateList = response.data

      const additionAffiliates = [
        {
          value: 'MP',
          label: 'MP',
        },
        {
          value: 'EL',
          label: 'EL',
        }
      ];

      this.affiliates.push(...additionAffiliates)

      affiliateList.forEach((affiliate) => {
        this.affiliates.push({
          value: affiliate.type,
          label: `${affiliate.displayname} (${affiliate.type})`,
        })
      })
    },
    handleAffiliteChange(affiliate) {
      this.handleResetAdvertiser()
      if (!affiliate) {
        this.advertisers = this.allAdvertisers
      } else {
        this.advertisers = []
        this.allAdvertisers.forEach((advertiser) => {
          if (advertiser.affiliate === affiliate) {
            this.advertisers.push(advertiser)
          }
        })
      }
    },
    handleAdvertiserChange(advertiser_str) {
      this.handleResetAdvertiser()
      let advertiser = advertiser_str.split(",,");
      this.filter.advertiser = advertiser_str
      this.filter.advertiser_id = advertiser[1]
      this.filter.advertiser_affiliate = advertiser[0]
    },
    handleResetAdvertiser() {
      this.filter.advertiser = ''
      this.filter.advertiser_id = ''
      this.filter.advertiser_affiliate = ''
    },
    async handleExportCSV() {
      this.isGeneratingCSV = true
      const payload = this.getPayload()
      try {
        const { data } = await generateSalesCSV(payload)
        // const { data } = response.data
        this.isGeneratingCSV = false

        this.$alert(data.message, 'Success', {
          confirmButtonText: 'OK',
          type: 'success',
        })
      } catch (error) {
        this.isGeneratingCSV = false
      }
    },
    handleSelectedDateRange(dateRange) {
      this.customDateRange = dateRange
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/view-base.scss";

section {
  .filter-item {
    margin: 3px 0;
    width: 100%;
    @include mobile {
      margin: 3px 5px;
      width: calc(100% / 3 - 10px);
    }
    @include tablet {
      width: calc(100% / 4 - 10px);
    }
    @include desktop {
      width: calc(100% / 6 - 10px);
    }
    span.filter-title {
      display: block;
    }
  }
  .data-picker-container {
    position: relative;
    // Make the hack button span the whole parent container.
    .absolute-view {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
    }
  }
}
</style>
